import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { ONBOARDING_API } from "../apiRoutes";

interface UseGetBulkUploadAuditRowsProps {
  communityId: string;
  data: any;
  queryKey?: any[];
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

// Row-level audit of committed uploads; filter by attachmentId for one upload
export const getBulkUploadAuditRows = async (communityId: string, data: any) =>
  await axiosAuth.post(`${ONBOARDING_API(communityId)}/occupancy/audits/grid`, data);

const useGetBulkUploadAuditRows = ({
  communityId,
  data,
  queryKey = [],
  queryParams,
}: UseGetBulkUploadAuditRowsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owner-bulk-upload-audit-rows", communityId, ...queryKey],
    queryFn: () => getBulkUploadAuditRows(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetBulkUploadAuditRows;
